export default __webpack_public_path__ + "static/media/imgpost7.960d964c.jpg";